import { render, staticRenderFns } from "./ExportRequestsModule.vue?vue&type=template&id=13e8f431"
import script from "./ExportRequestsModule.vue?vue&type=script&lang=js"
export * from "./ExportRequestsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports